const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')
const moduleRoute = {
  path: '/call-history',
  component: Module,
  children: [
    {
      path: '/',
      name: 'call-history',
      component: Home,
    },
  ],
  permissions: ['employee', 'rester_employee', 'dk_operator', 'dk_manager'],
}

export default router => {
  router.addRoutes([moduleRoute])
}
